import StaffPerformanceHTMLPreviewBaseColumnsStrategy from './StaffPerformanceHTMLPreviewBaseColumnsStrategy'

export default function StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy() {}

StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy.prototype = new StaffPerformanceHTMLPreviewBaseColumnsStrategy()

StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy.prototype.init = function(timeFormat, groupNameProvider, includeOtherUsersColumn) {
    StaffPerformanceHTMLPreviewBaseColumnsStrategy.prototype.init.call(this, timeFormat, groupNameProvider)
    this.includeOtherUsersColumn = includeOtherUsersColumn
    return this
}

StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy.prototype.addFirstHeaderRowCells = function(firstHeaderRow) {
    this.addCreatedCell(firstHeaderRow, this.createSpentHeaderCell())
    this.addCell(firstHeaderRow, this.getGroupNameSingular(), "userGroup", this.getDepartmentHeaderColumnWidth(), 1)
    if (this.includeOtherUsersColumn) {
        this.addCreatedCell(firstHeaderRow, this.createOthersHeaderCell(2))
    }
}

StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy.prototype.getDepartmentHeaderColumnWidth = function() {
    // abstract
}


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/staffperformance/StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy.js